const password_rejected = {
    too_short: 'حداقل طول {{min}} کاراکتر است.',
    too_long: 'حداکثر طول {{max}} کاراکتر است.',
    character_types: 'حداقل {{min}} نوع کاراکتر مورد نیاز است.',
    unsupported_characters: 'کاراکتر پشتیبانی‌نشده‌ای یافت شد.',
    pwned: 'از استفاده از رمزهای عبور ساده که به راحتی قابل حدس هستند خودداری کنید.',
    restricted_found: 'از استفاده بیش از حد {{list, list}} خودداری کنید.',
    restricted: {
        repetition: 'کاراکترهای تکراری',
        sequence: 'کاراکترهای متوالی',
        user_info: 'اطلاعات شخصی شما',
        words: 'محتوای مرتبط با محصول',
    },
};
export default Object.freeze(password_rejected);
